import {
  TextField,
  Typography,
  Grid,
  Box,
  Divider,
  Autocomplete,
  useTheme,
} from "@mui/material";

export default function ConfigureHost(props) {
  const {
    form,
    hostData,
    handleChange,
    errors,
    handleIpBlur,
    fabricantesOptions,
    modelosDisponiveis,
    optionsTipoInterfaceSNMP,
    proxys,
    optionsTipoAcesso,
    styles,
    hasDescription,
    isAdmin,
  } = props;
  const theme = useTheme();

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Box sx={styles.boxRowFields}>
          <Typography sx={styles.subtitle}>Nome</Typography>{" "}
          <TextField
            fullWidth
            placeholder="Nome do Host"
            name="nome"
            value={form.nome}
            onChange={handleChange}
            error={!!errors.nome}
            helperText={errors.nome}
            autoComplete="off"
            size="small"
          />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box sx={styles.boxRowFields}>
          <Typography sx={styles.subtitle}>IP</Typography>{" "}
          <TextField
            fullWidth
            placeholder="IP (IPv4 ou IPv6)"
            name="ip"
            value={form.ip}
            onChange={handleChange}
            onBlur={handleIpBlur}
            error={!!errors.ip}
            helperText={errors.ip}
            autoComplete="off"
            size="small"
          />
        </Box>
      </Grid>
      <Grid item xs={6}>
        <Box sx={styles.boxRowFields}>
          <Typography sx={styles.subtitle}>Fabricante</Typography>{" "}
          <Autocomplete
            id="multiple-limit-tags"
            size="small"
            name="fabricante"
            value={form.fabricante}
            onChange={(event, newValue) => {
              handleChange({
                target: {
                  name: "fabricante",
                  value: newValue,
                },
              });
            }}
            options={fabricantesOptions}
            getOptionLabel={(option) => option}
            renderOption={(optionProps, option, { index }) => {
              const { key, ...rest } = optionProps;
              return (
                <li {...rest} key={`${option}-${index}`}>
                  {option}
                </li>
              );
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                sx={styles.textfield}
                placeholder="Fabricante"
                error={!!errors.fabricante}
                helperText={errors.fabricante}
              />
            )}
          />
        </Box>
      </Grid>
      <Grid item xs={6}>
        <Box sx={styles.boxRowFields}>
          <Typography sx={styles.subtitle}>Modelo</Typography>{" "}
          <Autocomplete
            id="multiple-limit-tags"
            size="small"
            name="modelo"
            value={
              modelosDisponiveis.find((m) => m.value === form.modelo) || null
            }
            onChange={(event, newValue) => {
              handleChange({
                target: {
                  name: "modelo",
                  value: newValue?.value,
                  options: newValue?.predefinicoes,
                },
              });
            }}
            sx={{
              "& .MuiInputBase-root.Mui-disabled": {
                backgroundColor: theme.palette.background.card,
              },
            }}
            options={modelosDisponiveis}
            getOptionLabel={(option) => option?.label}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Modelo"
                error={!!errors.modelo}
                helperText={errors.modelo}
              />
            )}
            disabled={!form.fabricante}
          />
        </Box>
      </Grid>
      <Grid item xs={9}>
        <Box sx={styles.boxRowFields}>
          <Typography sx={styles.subtitle}>Tipo Interface</Typography>{" "}
          <Autocomplete
            id="multiple-limit-tags"
            size="small"
            name="tipoSNMP"
            value={
              optionsTipoInterfaceSNMP.find(
                (m) => m?.tipoInterface === form.tipoSNMP,
              ) || null
            }
            onChange={(event, newValue) => {
              handleChange({
                target: {
                  name: "tipoSNMP",
                  value: newValue,
                },
              });
            }}
            options={optionsTipoInterfaceSNMP}
            getOptionLabel={(option) => option.tipoInterface}
            getOptionDisabled={(option) =>
              hostData?.interfaceType == "2"
                ? option.tipoInterface === "PING/AGENTE"
                : hostData?.interfaceType == "1"
                  ? option.tipoInterface === "SNMPv1" ||
                    option.tipoInterface === "SNMPv2"
                  : null
            }
            renderInput={(params) => (
              <TextField
                {...params}
                sx={styles.textfield}
                placeholder="Tipo Interface"
                error={!!errors.tipoSNMP}
                helperText={errors.tipoSNMP}
              />
            )}
          />
        </Box>
      </Grid>
      <Grid item xs={3}>
        <Box sx={styles.boxRowFields}>
          <Typography sx={styles.subtitle}>Porta Interface</Typography>{" "}
          <TextField
            fullWidth
            type="number"
            placeholder="Porta"
            name="portaSNMP"
            value={form.portaSNMP}
            onChange={handleChange}
            error={!!errors.portaSNMP}
            helperText={errors.portaSNMP}
            autoComplete="off"
            size="small"
          />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box sx={styles.boxRowFields}>
          <Typography sx={styles.subtitle}>Proxy</Typography>{" "}
          <Autocomplete
            id="multiple-limit-tags"
            size="small"
            value={proxys.find((p) => p.proxyid === form.proxy) || null}
            options={proxys}
            getOptionLabel={(option) => option.host || ""}
            isOptionEqualToValue={(option, value) =>
              option.proxyid === value.proxyid
            }
            onChange={(event, newValue) => {
              handleChange({
                target: {
                  name: "proxy",
                  value: newValue ? newValue?.proxyid : "",
                },
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Proxy"
                sx={styles.textfield}
                error={!!errors.proxy}
                helperText={errors.proxy}
              />
            )}
            fullWidth
          />
        </Box>
      </Grid>
      {form.tipoSNMP && form.tipoSNMP !== "PING/AGENTE" && (
        <>
          {" "}
          <Grid item xs={12}>
            <Box sx={styles.boxRowFields}>
              <Typography sx={styles.subtitle}>Comunidade SNMP</Typography>{" "}
              <TextField
                fullWidth
                placeholder="Comunidade SNMP"
                name="comunidadeSnmp"
                value={form.comunidadeSnmp}
                onChange={handleChange}
                error={!!errors.comunidadeSnmp}
                helperText={errors.comunidadeSnmp}
                autoComplete="off"
                size="small"
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box sx={styles.boxRowFields}>
              <Typography sx={styles.subtitle}>Tipo Acesso</Typography>{" "}
              <Autocomplete
                id="multiple-limit-tags"
                size="small"
                name="tipoAcesso"
                value={form.tipoAcesso}
                onChange={(event, newValue) => {
                  handleChange({
                    target: {
                      name: "tipoAcesso",
                      value: newValue,
                    },
                  });
                }}
                options={optionsTipoAcesso}
                getOptionLabel={(option) => option}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    sx={styles.textfield}
                    placeholder="Tipo acesso"
                    error={!!errors.tipoAcesso}
                    helperText={errors.tipoAcesso}
                  />
                )}
              />
            </Box>
          </Grid>
        </>
      )}
      {form.tipoSNMP && form.tipoSNMP !== "PING/AGENTE" && form.tipoAcesso && (
        <>
          <Grid item xs={12}>
            <Divider />
            <Typography
              variant="subtitle2"
              color="text.secondary"
              sx={{ mt: 2 }}
            >
              {`Configuração ${form.tipoAcesso ? form.tipoAcesso : "SSH"} (Opcional)`}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Box sx={styles.boxRowFields}>
              <Typography sx={styles.subtitle}>Usuário</Typography>{" "}
              <TextField
                fullWidth
                placeholder="Usuario"
                name={form.tipoAcesso === "Telnet" ? "userTelnet" : "userSsh"}
                value={
                  form.tipoAcesso === "Telnet" ? form.userTelnet : form.userSsh
                }
                onChange={handleChange}
                error={
                  form.tipoAcesso === "Telnet"
                    ? !!errors.userTelnet
                    : !!errors.userSsh
                }
                helperText={
                  form.tipoAcesso === "Telnet"
                    ? errors.userTelnet
                    : errors.userSsh
                }
                autoComplete="off"
                size="small"
              />
            </Box>
          </Grid>
          <Grid item xs={9}>
            <Box sx={styles.boxRowFields}>
              <Typography sx={styles.subtitle}>Senha</Typography>{" "}
              <TextField
                fullWidth
                placeholder={"Senha"}
                name={form.tipoAcesso === "Telnet" ? "senhaTelnet" : "senhaSsh"}
                value={
                  form.tipoAcesso === "Telnet"
                    ? form.senhaTelnet
                    : form.senhaSsh
                }
                onChange={handleChange}
                error={
                  form.tipoAcesso === "Telnet"
                    ? !!errors.senhaTelnet
                    : !!errors.senhaSsh
                }
                helperText={
                  form.tipoAcesso === "Telnet"
                    ? errors.senhaTelnet
                    : errors.senhaSsh
                }
                autoComplete="off"
                size="small"
                type={isAdmin ? "text" : "password"}
              />
            </Box>
          </Grid>
          <Grid item xs={3}>
            <Box sx={styles.boxRowFields}>
              <Typography sx={styles.subtitle}>Porta</Typography>{" "}
              <TextField
                fullWidth
                type="number"
                placeholder={"Porta"}
                name={form.tipoAcesso === "Telnet" ? "portaTelnet" : "portaSsh"}
                value={
                  form.tipoAcesso === "Telnet"
                    ? form.portaTelnet
                    : form.portaSsh
                }
                onChange={handleChange}
                error={
                  form.tipoAcesso === "Telnet"
                    ? !!errors.portaTelnet
                    : !!errors.portaSsh
                }
                helperText={
                  form.tipoAcesso === "Telnet"
                    ? errors.portaTelnet
                    : errors.portaSsh
                }
                autoComplete="off"
                size="small"
              />
            </Box>
          </Grid>
        </>
      )}
      {hasDescription && (
        <Grid item xs={12}>
          <Box sx={styles.boxRowFields}>
            <Typography sx={styles.subtitle}>Descrição</Typography>{" "}
            <TextField
              fullWidth
              placeholder="Descrição do Host"
              name="descricao"
              value={form.descricao}
              onChange={handleChange}
              error={!!errors.descricao}
              autoComplete="off"
              size="small"
              multiline
              rows={4}
              inputProps={{ maxLength: 150 }}
              helperText="Limite de 255 dígitos"
            />
          </Box>
        </Grid>
      )}
    </Grid>
  );
}
